import { Component, Input } from '@angular/core';

@Component({
  selector: 'activity-row-sms',
  template: `
  <div style="float: left; margin-right: 10px;">
    <mat-icon>message</mat-icon>
  </div>

  <div class="description">

    <div class="text">
      <span *ngIf="activity.subType === 'outgoing'">
        <strong>Outgoing {{ activity.meta.automated ? ' Automated ' : '' }}
        Text Message
        {{ activity.meta.attemptNumber ? ' (SMS Attempt ' + activity.meta.attemptNumber + ')' : '' }}
        </strong> sent by
        {{ activity.meta.initiatorId === 992232 ? 'System Account' : activity.meta.lenderUserName }} to
      </span>

      <span *ngIf="activity.subType === 'incoming'"><strong>Incoming Text Message</strong> from</span>

      <span *ngIf="borrower.primary_contact && borrower.primary_contact.first">
        {{ borrower.primary_contact.first }} {{ borrower.primary_contact.last }}
      </span>

      <span *ngIf="!borrower.primary_contact && activity.subType === 'incoming'">
        {{ activity.fromNumber | phone }}
      </span>

      <span *ngIf="!borrower.primary_contact && activity.subType === 'outgoing'">
        {{ activity.meta.toNumber | phone }}
      </span>

      <span
        *ngIf="activity.meta.content"
        [matTooltip]="activity.meta.content.length > 80 ? activity.meta.content : ''">
        "{{ activity.meta.content | truncate:80 }}"
      </span>
    </div>

    <a *ngIf="borrower.status !== 'doNotContact'"
      [routerLink]="['/borrower/' + activity.borrowerId]"
      [queryParams]="{pane: 'messages', subpane: 'sms'}">
      &nbsp;View
    </a>
  </div>

  `,
    styles: [],
    standalone: false
})
export class ActivityRowSmsComponent {
  @Input() activity;
  @Input() borrower;
}
